import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-addmaterialsubject',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './addmaterialsubject.component.html',
  styleUrls: ['./addmaterialsubject.component.scss'],
})
export class AddmaterialsubjectComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  subjectName: any;
  year: any;
  category: any;
  cources: any[];
  courseData: any;
  showAdd = false;
  showEdit = false;
  materialdata: any[];
  subjectDetails;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    subjectval: [{ type: 'required', message: 'Please enter Subject' }],
    yearval: [{ type: 'required', message: 'Please enter Year' }],
    categorytypeval: [{ type: 'required', message: 'Please Select Category' }],
  };
  adminName: any;
  adminImage: any;
  allSubject: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      subjectval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      yearval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      categorytypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;

    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  deletematerialcategorysubject(id) {
    this.spinner.show();
    let payload = {
      id: id,
    };
    const servicePath = this.utils.getApiConfigs('materialcatergorysubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Category Delete Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  ngOnInit(): void {
    this.spinner.show();

    this.courseForm.reset();

    this.getmaterialcategory();
    this.getmaterialsubject();
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", this.category);

    this.allData = this.courseData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allSubject = this.allData.filter((item) =>
        item.category.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allSubject == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  addSubject1() {
    this.spinner.show();
    let payload = {
      material_cat_id: this.category,
      subject: this.subjectName,
      year: this.year,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('addsubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Subject added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  // editCourse(data){
  //   // console.log("Data", data);
  //   this.display = "block";
  //   this.showAdd = false;
  //   this.showEdit = true;

  //   this.courseName = data.courses;
  //   this.id = data.id;
  // }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  getmaterialcategory() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('getcategory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          console.log('----------------------', this.materialdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  getmaterialsubject() {
    this.spinner.show();
    const servicePath = this.utils.getApiConfigs('materialsubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.subjectDetails = resp.data;
          console.log('sasdsd', this.subjectDetails);

          // console.log("course details", JSON.stringify(this.courseDetails));

          if (this.subjectDetails == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }

        this.allSubject = this.subjectDetails;
        // console.log("All courses", this.allCourse);
      });
  }

  // updateCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //     "id": this.id
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course updated successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         // console.log("data", resp.data);
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //       }
  //     });
  // }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
